'use client';
import React from 'react';
import styles from './Particles.module.css';


export function Particles() {
  return (
    <>
        <div className={styles.space} >
            <div className={styles.particle} ></div>
            <div className={styles.particle} ></div>
            <div className={styles.particle} ></div>
            <div className={styles.particle} ></div>
        </div>
    </>
  );
}
export default Particles;